<template>
  <div class="vertrag-page">
    <div
      v-if="isCheckingAuth"
      class="state-block" data-state="loading" data-variant="auth"
    >
      <v-progress-circular
        indeterminate
        color="#EA5545"
        size="64"
      ></v-progress-circular>
      <p class="state-text">{{ t('contractDetail.auth.checking') }}</p>
      <p
        v-if="authError"
        class="state-text auth-error"
      >
        {{ authError }}
      </p>
    </div>

    <div
      v-else-if="!isAuthenticated"
      class="state-block" data-state="empty" data-variant="auth"
    >
      <v-icon size="80" color="#ccc">mdi-account-alert</v-icon>
      <h3 class="state-title">{{ t('contractDetail.auth.loginTitle') }}</h3>
      <p class="state-text">
        {{ t('contractDetail.auth.loginDescription') }}
      </p>
      <router-link to="/login">
        <v-btn
          color="#EA5545"
          variant="flat"
          prepend-icon="mdi-login"
        >
          {{ t('contractDetail.auth.loginButton') }}
        </v-btn>
      </router-link>
    </div>

    <template v-else>
      <div class="page-header">
        <div class="page-header-top">
          <h1 class="page-title">{{ pageTitle }}</h1>
          <v-btn
            v-if="routeHasId && currentContract"
            color="#EA5545"
            variant="flat"
            @click="startClearmentCare"
            class="header-cta-btn"
          >
            <v-icon left size="20">mdi-shield-account</v-icon>
            ClearmentCare starten
          </v-btn>
        </div>
      
      <!-- <div
        v-if="routeHasId && currentContract"
        class="primary-actions"
      >
        <router-link :to="helpLinkForContract" class="primary-action-link">
          <v-btn
            color="#EA5545"
            variant="flat"
            size="large"
            class="primary-action-btn"
          >
            <v-icon left size="22">mdi-shield-account</v-icon>
            {{ t('contractDetail.actions.askSupport') }}
          </v-btn>
        </router-link>
        <div class="primary-action-btn-wrapper">
          <v-btn
            color="#EA5545"
            variant="outlined"
            size="large"
            class="primary-action-btn"
            :disabled="!currentContract?.myp_id"
            @click="goToRechnung"
          >
            <v-icon left size="22">mdi-file-document-edit</v-icon>
            Rechnung einreichen
          </v-btn>
        </div>
      </div> -->

      <div
        v-if="showAdminContacts"
        class="admin-contact-card"
      >
        <div class="admin-contact-header">
          <v-icon size="24" color="#EA5545">mdi-account-group</v-icon>
          <div>
            <div class="admin-contact-title">{{ t('contractDetail.adminHelpers.title') }}</div>
            <div class="admin-contact-subtitle">{{ t('contractDetail.adminHelpers.subtitle') }}</div>
          </div>
        </div>
        <div class="admin-contact-list">
          <div
            v-for="admin in limitedAdmins"
            :key="admin.user_id"
            class="admin-contact-item"
          >
            <div class="admin-contact-avatar">
              <img
                v-if="admin.user_thumb"
                :src="`/getfile/${admin.user_thumb}`"
                alt="Admin Avatar"
              />
              <v-icon v-else size="18" color="#fff">mdi-account</v-icon>
            </div>
            <div class="admin-contact-info">
                <div class="admin-contact-name">{{ admin.user_admin_name || admin.user_name }}</div>
              <div class="admin-contact-company">{{ admin.com_name || admin.user_email }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="isLoading" class="state-block" data-state="loading">
      <v-progress-circular
        indeterminate
        color="#EA5545"
        size="64"
      ></v-progress-circular>
      <p class="state-text">{{ t('contractDetail.loading.contracts') }}</p>
    </div>

    <!-- Verträge Übersicht (ohne Route-ID) -->
    <div
      v-else-if="!routeHasId && contracts.length > 0"
      class="contracts-list"
    >
      <ContractList :contracts="contracts" />
    </div>

    <!-- AI Suche & Support-Anfragen zum Vertrag (nur im Detailmodus) -->
    <div
      v-if="routeHasId && currentContract"
      class="supports-section"
    >
      <!-- Statistik-Box -->
      <!-- <v-card class="stats-card" elevation="1">
        <v-card-text>
       -->

          <div class="stats-grid stats-panels">
            <div class="stat-panel">
              <div class="stat-panel-header">
                <div class="stat-panel-icon">
                  <v-icon size="24" color="#EA5545">mdi-lifebuoy</v-icon>
                </div>
                <div>
                  <div class="stat-panel-title">ClearmentCare</div>
                  <div class="stat-panel-subtitle">Support-Status für diesen Vertrag</div>
                </div>
              </div>
              <div class="stat-panel-metrics">
                <div class="stat-metric" v-if="supportStats.tickets > 0">
                  <div class="stat-metric-value">{{ supportStats.tickets }}</div>
                  <div class="stat-metric-label">Support-Tickets</div>
                </div>
                <div class="stat-metric" v-if="supportStats.attachments > 0">
                  <div class="stat-metric-value">{{ supportStats.attachments }}</div>
                  <div class="stat-metric-label">Support-Anhänge</div>
                </div>
                <div class="stat-metric" v-if="supportStats.unread > 0">
                  <div class="stat-metric-value">{{ supportStats.unread }}</div>
                  <div class="stat-metric-label">Ungelesen</div>
                </div>
              </div>
              <div class="stat-panel-actions">
                <div class="stat-metric pill-metric" @click="startClearmentCare">
                  <v-icon size="18" color="#EA5545" class="mr-1">mdi-shield-account</v-icon>
                  <span>ClearmentCare starten</span>
                </div>
                <div class="stat-metric pill-metric" @click="goToSupportList">
                  <v-icon size="18" color="#EA5545" class="mr-1">mdi-ticket</v-icon>
                  <span>Alle Tickets öffnen</span>
                </div>
              </div>
            </div>

            <div class="stat-panel">
              <div class="stat-panel-header">
                <div class="stat-panel-icon">
                  <v-icon size="24" color="#EA5545">mdi-brain</v-icon>
                </div>
                <div>
                  <div class="stat-panel-title">Clearment.AI Chat</div>
                  <div class="stat-panel-subtitle">Clearment.AI analysiert deinen Vertrag und beantwortet Deine Fragen.</div>
                </div>
              </div>
              <div class="stat-panel-metrics single">
                <div class="stat-metric" v-if="aiStats.requests > 0">
                  <div class="stat-metric-value">{{ aiStats.requests }}</div>
                  <div class="stat-metric-label">AI Chats</div>
                </div>
              </div>
              <div class="stat-panel-actions">
                <div
                  class="stat-metric pill-metric"
                  :class="{ disabled: !currentContractSupportsBrainSearch || !currentContract?.myp_product_id }"
                  @click="currentContractSupportsBrainSearch && currentContract?.myp_product_id && openBrainDialog()"
                >
                  <v-icon size="18" color="#EA5545" class="mr-1">mdi-brain</v-icon>
                  <span>Clearment.AI Chat starten</span>
                </div>
                <div
                  class="stat-metric pill-metric"
                  :class="{ disabled: !currentContract?.myp_product_id }"
                  @click="currentContract?.myp_product_id && goToBrainRequests()"
                >
                  <v-icon size="18" color="#EA5545" class="mr-1">mdi-open-in-new</v-icon>
                  <span>Zu Deinen Clearment.AI Chats</span>
                </div>
              </div>
            </div>

            <div class="stat-panel">
              <div class="stat-panel-header">
                <div class="stat-panel-icon">
                  <v-icon size="24" color="#EA5545">mdi-file-document</v-icon>
                </div>
                <div>
                  <div class="stat-panel-title">Vertragsmanagement</div>
                  <div class="stat-panel-subtitle">Versicherungsdokumente,Rechnung einreichen & Clearment "Klarvertrag"</div>
                </div>
              </div>
              <div class="stat-panel-metrics">
                <div class="stat-metric" v-if="managementStats.docs > 0">
                  <div class="stat-metric-value">{{ managementStats.docs }}</div>
                  <div class="stat-metric-label">Vertragsdokumente</div>
                </div>
                <div class="stat-metric pill-metric" @click="goToRechnung">
                  <v-icon size="18" color="#EA5545" class="mr-1">mdi-file-document-edit</v-icon>
                  <span>Rechnung einreichen</span>
                </div>
                <div
                  class="stat-metric pill-metric"
                  v-if="managementStats.hasKlarvertrag"
                  @click="goToKlarvertrag"
                >
                  <v-icon size="18" color="#EA5545" class="mr-1">mdi-file-eye</v-icon>
                  <span>Der Clearment "Klarvertrag"  {{ managementStats.klarvertragLabel || 'Clearment Klarvertrag' }}</span>
                </div>
              </div>
              <div class="stat-panel-actions">
                <div
                  class="stat-metric pill-metric"
                  :class="{ disabled: !currentContract?.myp_id }"
                  @click="currentContract?.myp_id && goToDokumente()"
                >
                  <v-icon size="18" color="#EA5545" class="mr-1">mdi-folder-open</v-icon>
                  <span>Vertrags-Dokumente</span>
                </div>
              </div>
            </div>
          </div>

          <v-divider class="my-4"></v-divider>

          <div
            v-if="hasContractNumber"
            class="contract-number-inline"
          >
            <div class="contract-number-inline-text">
              <span class="contract-number-label">Vertragsnummer:</span>
              <span class="contract-number-value">
                {{ currentContract.myp_vertrags_nummer }}
              </span>
            </div>
            <v-btn
              variant="text"
              color="#EA5545"
              size="small"
              class="contract-number-edit-btn"
              @click="showContractNumberCard = !showContractNumberCard"
            >
              <v-icon left size="18">mdi-file-document-edit</v-icon>
              Vertragsnummer bearbeiten
            </v-btn>
          </div>

          <div
            v-if="!hasContractNumber || showContractNumberCard"
            class="contract-number-card"
          >
            <div class="stats-header compact">
              <v-icon size="22" color="#EA5545" class="mr-2">mdi-file-document-edit</v-icon>
              <div class="stats-title-block">
                <div class="stats-title">Vertragsnummer bearbeiten</div>
                <div class="stats-subtitle">
                  Hier kannst du die Vertragsnummer deines Produkts aktualisieren.
                </div>
              </div>
            </div>

            <v-text-field
              v-model="contractNumber"
              label="Vertragsnummer"
              placeholder="z.B. VN-123456"
              variant="outlined"
              class="mb-4"
              :error-messages="contractNumberError ? [contractNumberError] : []"
              @input="contractNumberError = ''"
            ></v-text-field>

            <div class="new-ticket-actions">
              <v-btn
                color="#EA5545"
                variant="flat"
                :loading="isSavingContractNumber"
                :disabled="isSavingContractNumber || !contractNumber"
                @click="saveContractNumber"
              >
                <v-icon left>mdi-content-save</v-icon>
                Vertragsnummer speichern
              </v-btn>
            </div>
          </div>

        <!-- </v-card-text>
      </v-card> -->

    <BrainSimple
      v-if="currentContractSupportsBrainSearch && currentContract?.prod_klv_id"
      class="brain-search-inline"
      :productId="currentContract.prod_klv_id"
      :productName="currentContract.prod_name || 'Unknown Product'"
      @search-completed="handleBrainSearchCompleted"
    />

      <div class="supports-header">
        <h2 class="supports-title">Support-Anfragen zu diesem Vertrag</h2>
      </div>

      <div v-if="isLoadingSupports" class="state-block" data-state="loading" data-size="sm">
        <v-progress-circular
          indeterminate
          color="#EA5545"
          size="32"
        ></v-progress-circular>
        <p class="state-text">Support-Anfragen werden geladen...</p>
      </div>

      <div
        v-else-if="relatedSupports.length > 0"
        class="supports-list"
      >
        <ContractSupportItem
          v-for="support in relatedSupports"
          :key="support.sup_id"
          :support="support"
        />
      </div>

      <div v-else class="state-block" data-state="empty" data-size="sm">
        <v-icon size="40" color="#ccc">mdi-ticket-outline</v-icon>
        <h3 class="state-title" data-size="sm">Keine Support-Anfragen</h3>
        <p class="state-text">
          Für diesen Vertrag wurden bisher keine Support-Tickets erstellt.
        </p>
      </div>

      <div class="brain-requests-section">
        <div class="section-title-row">
          <h3 class="section-title">
            <v-icon size="18" class="mr-2" color="#EA5545">mdi-brain</v-icon>
            Letzte Clearment.AI Chats
          </h3>
          <router-link
            :to="{
              name: 'brain',
              params: currentContract?.myp_product_id
                ? { productid: currentContract.myp_product_id }
                : {}
            }"
            class="view-all-link"
          >
            Alle anzeigen
            <v-icon size="16" class="ml-1">mdi-arrow-right</v-icon>
          </router-link>
        </div>

        <div v-if="isLoadingBrainRequests" class="state-block" data-state="loading" data-size="sm">
          <v-progress-circular
            indeterminate
            color="#EA5545"
            size="32"
          ></v-progress-circular>
          <p class="state-text">Clearment.AI Chats werden geladen...</p>
        </div>

        <div
          v-else-if="contractBrainRequests.length > 0"
          class="brain-request-list"
        >
          <div
            v-for="request in contractBrainRequests"
            :key="request.breq_id"
            class="brain-request-card"
            @click="goToBrainRequestDetail(request)"
          >
            <div class="brain-request-header">
              <v-chip
                size="x-small"
                :color="request.breq_status === 2 ? 'red' : request.breq_status === 1 ? 'green' : 'orange'"
                variant="tonal"
              >
                {{ request.breq_status === 2 ? 'Fehler' : request.breq_status === 1 ? 'Fertig' : 'In Arbeit' }}
              </v-chip>
              <span class="brain-request-date">
                {{ formatDate(request.breq_created_date) }}
              </span>
            </div>
            <p class="brain-request-text">
              {{ request.breq_prompt }}
            </p>
          </div>
        </div>

        <div v-else class="state-block" data-state="empty" data-size="sm">
          <v-icon size="40" color="#ccc">mdi-brain</v-icon>
          <h3 class="state-title" data-size="sm">Keine Clearment.AI Chats</h3>
          <p class="state-text">
            Für diesen Vertrag wurden noch keine Clearment.AI Chats gestellt.
          </p>
        </div>
      </div>

    </div>

    <!-- Route-ID, aber kein Vertrag gefunden -->
    <div
      v-else-if="routeHasId"
      class="state-block" data-state="empty"
    >
      <v-icon size="80" color="#ccc">mdi-file-question</v-icon>
      <h3 class="state-title">Vertrag nicht gefunden</h3>
      <p class="state-text">
        Der angeforderte Vertrag existiert nicht oder gehört nicht zu deinem Account.
      </p>
      <router-link to="/vertrag">
        <v-btn
          color="#EA5545"
          variant="text"
          prepend-icon="mdi-arrow-left"
        >
          Alle Verträge anzeigen
        </v-btn>
      </router-link>
    </div>

    <!-- Keine Verträge -->
    <div
      v-else
      class="state-block" data-state="empty"
    >
      <v-icon size="80" color="#ccc">mdi-file-document-outline</v-icon>
      <h3 class="state-title">Noch keine Verträge</h3>
      <p class="state-text">
        Dir sind aktuell keine Verträge in <code>cl_my_product</code> zugeordnet.
      </p>
    </div>
    </template>
  </div>

  <!-- Clearment.AI Dialog -->
  <v-dialog
    v-if="isAuthenticated && currentContractSupportsBrainSearch"
    v-model="showBrainDialog"
    max-width="900"
  >
    <v-card>
      <v-card-title class="dialog-title">
        <div class="dialog-title-row">
          <div class="dialog-title-main">
            <v-icon size="24" color="#EA5545" class="mr-2">mdi-brain</v-icon>
            Clearment.AI für diesen Vertrag
          </div>
          <div class="dialog-title-spacer"></div>
          <v-btn icon variant="text" @click="showBrainDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
    
        <BrainSearch
          :showHistory="false"
          :presetProductId="currentContract?.myp_product_id"
          :lockProductSelection="true"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
/* global defineProps */
import { ref, inject, onMounted, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import BrainSearch from '@/components/objects/BrainSearch.vue'
import BrainSimple from '@/components/objects/BrainSimple.vue'
import ContractSupportItem from '@/components/objects/ContractSupportItem.vue'
import ContractList from '@/components/objects/ContractList.vue'
import { CLEARMENT_TITLE, CLEARMENT_DESCRIPTION } from '@/constants/documentHead'
import { useLanguage } from '@/composables/useLanguage'

const props = defineProps({
  initialMypId: {
    type: [Number, String],
    default: null
  }
})

const baseCalls = inject('baseCalls')
const userStore = inject('userStore')
const errorStore = inject('errorStore')
const successStore = inject('successStore')
const route = useRoute()
const router = useRouter()
const { t } = useLanguage()
const updateDocumentHead = inject('updateDocumentHead')
updateDocumentHead?.(CLEARMENT_TITLE, CLEARMENT_DESCRIPTION)
//const baseStore = useBaseStore()

const fallbackUserRef = ref(null)
const { userData } = userStore ? storeToRefs(userStore) : { userData: fallbackUserRef }

const isCheckingAuth = ref(true)
const isEnsuringLogin = ref(false)
const isAuthenticated = ref(false)
const authError = ref('')

const contracts = ref([])
const isLoading = ref(false)
const supports = ref([])
const isLoadingSupports = ref(false)
const contractBrainRequests = ref([])
const isLoadingBrainRequests = ref(false)
const showBrainDialog = ref(false)
const defaultProductStats = {
  support_count: 0,
  file_count: 0,
  brain_count: 0,
  doc_count: 0
}
const productStats = ref({ ...defaultProductStats })
const contractNumber = ref('')
const isSavingContractNumber = ref(false)
const contractNumberError = ref('')
const showContractNumberCard = ref(false)
const companyAdmins = ref([])
const isLoadingAdmins = ref(false)
const adminsLoaded = ref(false)
const isCustomer = computed(() => Number(userData.value?.user_admin || 0) === 0)
const limitedAdmins = computed(() => companyAdmins.value.slice(0, 3))
const showAdminContacts = computed(() => isCustomer.value && limitedAdmins.value.length > 0)

function resetPageState() {
  contracts.value = []
  supports.value = []
  contractBrainRequests.value = []
  productStats.value = { ...defaultProductStats }
  contractNumber.value = ''
  contractNumberError.value = ''
  showContractNumberCard.value = false
  isLoading.value = false
  isLoadingSupports.value = false
  isLoadingBrainRequests.value = false
}

const routeId = computed(() => {
  if (props.initialMypId !== null && props.initialMypId !== undefined) {
    return Number(props.initialMypId)
  }
  const rawId = route.params.id
  if (!rawId && rawId !== 0) return null
  const parsed = Number(rawId)
  return Number.isNaN(parsed) ? null : parsed
})

const routeHasId = computed(() => routeId.value !== null)

const currentContract = computed(() => {
  if (!routeHasId.value) return null
  return contracts.value.find(contract => Number(contract.myp_id) === routeId.value) || null
})

const currentContractSupportsBrainSearch = computed(() => {
  const contract = currentContract.value
  if (!contract) return false
  return Number(contract.prod_brain_search || 0) === 1
})

const relatedSupports = computed(() => {
  if (!currentContract.value) return []
  const productId = Number(currentContract.value.myp_product_id)
  if (!productId) return []
  return supports.value.filter(support => Number(support.sup_product_id) === productId)
})

const pageTitle = computed(() => {
  if (routeHasId.value && currentContract.value) {
    return `Clearment Vertragschutz ${currentContract.value.prod_name || ''}`.trim()
  }
  return 'Meine Verträge'
})

const hasContractNumber = computed(() => {
  if (!currentContract.value) return false
  const num = currentContract.value.myp_vertrags_nummer
  return typeof num === 'string' ? num.trim().length > 0 : !!num
})

// const helpLinkForContract = computed(() => {
//   const contractId = currentContract.value?.myp_id
//   if (!contractId) {
//     return { name: 'help' }
//   }
//   return {
//     name: 'help',
//     params: { id: contractId }
//   }
// })

const contractSupports = computed(() => {
  if (!currentContract.value) return []
  const contractProductId = Number(currentContract.value.myp_product_id || currentContract.value.myp_id || 0)
  if (!contractProductId) return supports.value || []
  return (supports.value || []).filter(s => {
    const supProduct = Number(s.sup_product_id || s.myp_product_id || s.prod_id || s.product_id || 0)
    return supProduct === contractProductId
  })
})

const supportStats = computed(() => {
  const stats = productStats.value
  const tickets = stats.support_count ?? contractSupports.value.length ?? 0
  const attachments = stats.file_count ?? 0
  const unread = contractSupports.value.reduce((sum, s) => {
    const val = Number(s.unread_count ?? s.sup_unread ?? s.sup_unread_count ?? 0)
    return sum + (isNaN(val) ? 0 : val)
  }, 0)
  return { tickets, attachments, unread }
})

const aiStats = computed(() => {
  const requests = productStats.value.brain_count ?? contractBrainRequests.value.length ?? 0
  return { requests }
})

const managementStats = computed(() => {
  const docs = productStats.value.doc_count ?? 0
  const hasKlarvertrag = Number(currentContract.value?.prod_klv_type || 0) > 0 && Number(currentContract.value?.prod_klv_id || 0) > 0
  const klarvertragLabel =
    currentContract.value?.prod_klv_label ||
    `LSK ${currentContract.value?.prod_klv_type || ''}`.trim()
  return { docs, hasKlarvertrag, klarvertragLabel }
})

async function ensureLoginData() {
  if (userData.value) {
    return true
  }
  if (isEnsuringLogin.value) {
    return !!userData.value
  }
  if (!baseCalls || typeof baseCalls.userGet !== 'function') {
    return false
  }
  isEnsuringLogin.value = true
  authError.value = ''
  try {
    const response = await baseCalls.userGet({ action: 'loggeduser', id: 0 })
    if (response?.data?.user) {
      userStore?.setUser?.(response.data.user)
      return true
    }
    return false
  } catch (err) {
    console.error('Error checking login status for /vertrag:', err)
    authError.value = 'Dein Login-Status konnte nicht geprüft werden.'
    return false
  } finally {
    isEnsuringLogin.value = false
  }
}

async function initializePage() {
  isCheckingAuth.value = true
  authError.value = ''
  try {
    if (!userData.value) {
      await ensureLoginData()
    }
    isAuthenticated.value = !!userData.value
    if (isAuthenticated.value) {
      await loadContracts()
      if (routeHasId.value) {
        await loadSupports()
      }
      if (isCustomer.value && !adminsLoaded.value) {
        await loadCompanyAdmins()
      }
    } else {
      resetPageState()
    }
  } finally {
    isCheckingAuth.value = false
  }
}

async function loadContracts() {
  if (!isAuthenticated.value) return
  isLoading.value = true
  try {
    const response = await baseCalls.clearmentPost({
      action: 'getmyproducts'
    })

    if (response.data.success && response.data.products) {
      contracts.value = response.data.products
    } else {
      contracts.value = []
    }
  } catch (err) {
    console.error('Error loading contracts:', err)
    if (errorStore && typeof errorStore.setError === 'function') {
      errorStore.setError(true, 'Verträge konnten nicht geladen werden')
    }
    contracts.value = []
  } finally {
    isLoading.value = false
  }
}

async function loadSupports() {
  if (!isAuthenticated.value) {
    supports.value = []
    return
  }
  isLoadingSupports.value = true
  try {
    const response = await baseCalls.clearmentPost({
      action: 'getAllMySupports'
    })

    if (response.data.success && response.data.supports) {
      supports.value = response.data.supports
    } else {
      supports.value = []
    }
  } catch (err) {
    console.error('Error loading supports:', err)
    if (errorStore && typeof errorStore.setError === 'function') {
      errorStore.setError(true, 'Support-Anfragen konnten nicht geladen werden')
    }
    supports.value = []
  } finally {
    isLoadingSupports.value = false
  }
}

async function loadBrainRequestsForContract() {
  if (!isAuthenticated.value) {
    contractBrainRequests.value = []
    return
  }
  if (!currentContract.value || !currentContract.value.myp_product_id) {
    contractBrainRequests.value = []
    return
  }

  isLoadingBrainRequests.value = true
  try {
    const response = await baseCalls.clearmentPost({
      action: 'getmybrainrequests'
    })

    if (response.data.success && Array.isArray(response.data.requests)) {
      const productId = Number(currentContract.value.myp_product_id)
      const filtered = response.data.requests
        .filter(req => Number(req.breq_product_id) === productId)
        .slice(0, 10)
      contractBrainRequests.value = filtered
    } else {
      contractBrainRequests.value = []
    }
  } catch (err) {
    console.error('Error loading brain requests for contract:', err)
    contractBrainRequests.value = []
  } finally {
    isLoadingBrainRequests.value = false
  }
}

async function loadProductStats() {
  if (!isAuthenticated.value) return
  if (!currentContract.value || !currentContract.value.myp_product_id) return
  try {
    const response = await baseCalls.clearmentPost({
      action: 'getproductstats',
      prod_id: currentContract.value.myp_product_id
    })
    if (response.data.success && response.data.stats) {
      productStats.value = {
        support_count: response.data.stats.support_count ?? 0,
        file_count: response.data.stats.file_count ?? 0,
        brain_count: response.data.stats.brain_count ?? 0,
        doc_count: response.data.stats.doc_count ?? 0
      }
    } else {
      productStats.value = { ...defaultProductStats }
    }
  } catch (err) {
    console.error('Error loading product stats:', err)
    productStats.value = { ...defaultProductStats }
  }
}

async function saveContractNumber() {
  if (!currentContract.value) return
  const value = (contractNumber.value || '').trim()

  if (!value) {
    contractNumberError.value = 'Vertragsnummer darf nicht leer sein'
    return
  }

  isSavingContractNumber.value = true
  contractNumberError.value = ''

  try {
    const response = await baseCalls.clearmentPost({
      action: 'updatecontractnumber',
      myp_id: currentContract.value.myp_id,
      myp_vertrags_nummer: value
    })

    if (response.data.success) {
      // Lokalen Vertrag in der Liste aktualisieren
      const updated = response.data.product || null
      const mypId = Number(currentContract.value.myp_id)
      const idx = contracts.value.findIndex(c => Number(c.myp_id) === mypId)
      if (idx !== -1) {
        contracts.value[idx] = {
          ...contracts.value[idx],
          ...(updated || {}),
          myp_vertrags_nummer: value
        }
      }

      if (successStore && typeof successStore.setSuccess === 'function') {
        successStore.setSuccess(
          true,
          'Vertragsnummer gespeichert',
          'Die Vertragsnummer wurde erfolgreich aktualisiert.'
        )
      }
    } else {
      contractNumberError.value = response.data.message || 'Vertragsnummer konnte nicht gespeichert werden'
    }
  } catch (err) {
    console.error('Error updating contract number:', err)
    contractNumberError.value = 'Beim Speichern der Vertragsnummer ist ein Fehler aufgetreten'
  } finally {
    isSavingContractNumber.value = false
  }
}

function goToKlarvertrag() {
  if (!currentContract.value || !currentContract.value.prod_klv_id) return
  router.push({
    name: 'klarvertrag',
    params: { tarifId: currentContract.value.prod_klv_id }
  })
}

function goToBrainRequests() {
  if (!currentContract.value || !currentContract.value.myp_product_id) return
  router.push({
    name: 'brain',
    params: { productid: currentContract.value.myp_product_id }
  })
}

function openBrainDialog() {
  if (!currentContractSupportsBrainSearch.value || !currentContract.value?.myp_product_id) return
  showBrainDialog.value = true
}

function goToSupportList() {
  router.push('/support')
}

function startClearmentCare() {
  const contractId = currentContract.value?.myp_id
  if (contractId) {
    router.push({
      name: 'help',
      params: { id: contractId }
    })
  } else {
    router.push({ name: 'help' })
  }
}

function goToBrainRequestDetail(request) {
  if (!request) return
  if (currentContract.value?.myp_product_id) {
    router.push({
      name: 'brain',
      params: {
        productid: currentContract.value.myp_product_id,
        id: request.breq_id
      }
    })
  } else {
    router.push({
      name: 'brain',
      params: { id: request.breq_id }
    })
  }
}

async function handleBrainSearchCompleted() {
  await loadBrainRequestsForContract()
}

async function loadCompanyAdmins() {
  if (!baseCalls?.userPost || isLoadingAdmins.value || adminsLoaded.value) return
  isLoadingAdmins.value = true
  try {
    const response = await baseCalls.userPost({ action: 'getcompanyadmins' })
    if (response.data?.success && Array.isArray(response.data.admins)) {
      companyAdmins.value = response.data.admins
      adminsLoaded.value = true
    } else {
      companyAdmins.value = []
    }
  } catch (err) {
    console.error('Error loading company admins (VertragIndex):', err)
    companyAdmins.value = []
  } finally {
    isLoadingAdmins.value = false
  }
}

function goToRechnung() {
  if (!currentContract.value || !currentContract.value.myp_id) return
  router.push({
    name: 'rechnung',
    params: { tarifId: currentContract.value.myp_id }
  })
}

function formatDate(dateString) {
  if (!dateString || dateString === '1973-01-01 00:00:00') return 'N/A'
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return 'N/A'
  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

function goToDokumente() {
  if (!currentContract.value || !currentContract.value.myp_id) return
  router.push({
    name: 'dokumente',
    params: { id: currentContract.value.myp_id }
  })
}

// function goToHelp() {
//   if (!currentContract.value?.myp_id) return
//   router.push({
//     name: 'help',
//     params: { id: currentContract.value.myp_id }
//   })
// }

onMounted(() => {
  initializePage()
})

watch(
  userData,
  (newUser, oldUser) => {
    if (newUser) {
      const becameAuthenticated = !isAuthenticated.value
      isAuthenticated.value = true
      if (becameAuthenticated || !oldUser) {
        loadContracts()
        if (routeHasId.value) {
          loadSupports()
        }
        if (isCustomer.value && !adminsLoaded.value) {
          loadCompanyAdmins()
        }
      }
    } else {
      isAuthenticated.value = false
      resetPageState()
      companyAdmins.value = []
      adminsLoaded.value = false
    }
  }
)

// Beobachte Auth- und Routenstatus, um abhängige Daten neu zu laden
watch(
  () => ({
    auth: isAuthenticated.value,
    hasId: routeHasId.value,
    prodId: currentContract.value?.myp_product_id || null
  }),
  (state, prevState) => {
    if (!state.auth) {
      contractBrainRequests.value = []
      productStats.value = { ...defaultProductStats }
      return
    }

    if (!state.hasId) {
      contractBrainRequests.value = []
      return
    }

    const shouldReloadBrain =
      !prevState ||
      state.auth !== prevState.auth ||
      state.hasId !== prevState.hasId ||
      state.prodId !== prevState.prodId

    if (shouldReloadBrain) {
      loadBrainRequestsForContract()
    }

    const shouldReloadStats =
      !!state.prodId &&
      (!prevState || state.prodId !== prevState.prodId || !prevState.auth)

    if (shouldReloadStats) {
      loadProductStats()
    }
  },
  { immediate: true }
)

watch(
  () => ({
    auth: isAuthenticated.value,
    routeId: route.params.id || null
  }),
  (state, prevState) => {
    if (!state.auth) {
      supports.value = []
      return
    }

    if (!state.routeId) {
      supports.value = []
      return
    }

    if (!prevState || state.routeId !== prevState.routeId || !prevState.auth) {
      loadSupports()
    }
  }
)

// Vertragsnummer-Feld befüllen, wenn der aktuelle Vertrag geladen wird
watch(
  () => currentContract.value,
  (newContract) => {
    if (newContract) {
      contractNumber.value = newContract.myp_vertrags_nummer || ''
      contractNumberError.value = ''
      // Wenn noch keine Nummer vorhanden ist, Card direkt anzeigen, sonst zunächst verstecken
      showContractNumberCard.value = !newContract.myp_vertrags_nummer
    } else {
      contractNumber.value = ''
      contractNumberError.value = ''
      showContractNumberCard.value = false
    }
  },
  { immediate: true }
)
</script>

<style scoped src="@/assets/styles/sfc/components/sites/VertragIndex.css"></style>
